import { render, staticRenderFns } from "./EcommBanner.vue?vue&type=template&id=0a75c84a&scoped=true"
import script from "./EcommBanner.vue?vue&type=script&lang=js"
export * from "./EcommBanner.vue?vue&type=script&lang=js"
import style0 from "./EcommBanner.vue?vue&type=style&index=0&id=0a75c84a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a75c84a",
  null
  
)

export default component.exports